import Connexion from "../../modules/administration/Connexion.vue";
import EmailVerification from "../../modules/administration/EmailVerification.vue"
import ResetPassword from "../../modules/administration/ResetPassword.vue";

const routes = [
    { 
        path: '/connexion', 
        component: Connexion 
    },
    { 
        path: '/email-verification', 
        component: EmailVerification 
    },
    { 
        path: '/reset-password', 
        component: ResetPassword 
    },
];

export default routes;